import { FC, RefObject } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { useMediaQuery } from "react-responsive";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { Header } from "src/components/Header";
import { MobHeader } from "src/components/MobHeader";
import { SCREEN_BREAKPOINTS } from "src/constants/screenBreakpoints";
import { scrollToComponent } from "src/utils/scrollToComponent";
import mobileBanner from "src/assets/images/opportunities/banner/opportunities-bg-mob.png";
import { bannerTrns } from "./trns";

const MOBILE_BANNER_ALT_TEXT = "Opportunities - Businnes clone";

interface Props {
  sectionRef?: RefObject<HTMLElement>;
}

export const Banner: FC<Props> = ({ sectionRef }) => {
  const { t } = useTranslation();

  const onClick = () => scrollToComponent(sectionRef);

  const isMDScreenBreakpoint = useMediaQuery({
    minWidth: SCREEN_BREAKPOINTS.MD,
  });

  return (
    <div
      className={cn("bg-cover bg-center bg-no-repeat mt-19 lg:mt-0", {
        "bg-opportunities-banner": isMDScreenBreakpoint,
      })}
    >
      <Header />
      <MobHeader />

      {!isMDScreenBreakpoint && (
        <div>
          <img
            className="w-full"
            src={mobileBanner}
            alt={MOBILE_BANNER_ALT_TEXT}
          />
        </div>
      )}

      <div className="container">
        <div className="flex flex-col items-start gap-10 py-10 md:pt-72 lg:pt-90 lg:pb-72 lg:max-w-155">
          <h1 className="text-purple-base text-xl text-20 lg:text-52">
            {t(bannerTrns.title)}
          </h1>

          <p className="text-purple-base text-justify lg:text-xl font-thin">
            {t(bannerTrns.description)}
          </p>

          <Button
            variant={ButtonVariants.PRIMARY}
            className="lg:text-xl lg:font-medium px-5 w-full sm:max-w-64"
            onClick={onClick}
          >
            {t(bannerTrns.listOfPossibilitiesButton)}
          </Button>
        </div>
      </div>
    </div>
  );
};
